<div class="container">
  <h1 class="header">
    <div class="title">
      <mat-icon class="success">check_circle_outline</mat-icon
      >設定検証が完了しました
    </div>
    <button
      type="button"
      mat-icon-button
      class="close-button"
      (click)="this.close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <div class="main">
    <div class="success-message">
      <p>
        Salesforceとの連携設定が正常に検証されました。連携設定に進んでください。<br />自動連携は連携設定の保存後に開始されます。
      </p>
    </div>
  </div>
  <div class="footer">
    <button rectangle variant="primary" (click)="this.close()">OK</button>
  </div>
</div>
